// Objectionable-content filter — App Review guideline 1.2 requires UGC apps to
// ship "a method for filtering objectionable content" alongside flag/block and
// a human moderation queue. This is deliberately a NARROW zero-tolerance list
// (slurs, targeted abuse, sexual violence), not a profanity filter: the app is
// 17+/drinking-age and ordinary swearing is normal squad chat. The human
// moderation queue in AdminDashboard is the real backstop; this is the
// first-line automated layer.

// Leetspeak/symbol substitutions people use to slip past filters.
const LEET = { '0': 'o', '1': 'i', '3': 'e', '4': 'a', '5': 's', '7': 't', '@': 'a', '$': 's', '!': 'i' };

function normalizeToken(tok) {
  return tok
    .toLowerCase()
    .replace(/[013457@$!]/g, (c) => LEET[c])
    .replace(/[^a-z]/g, '');
}

// Matched as substrings of any single (normalized) token — long enough that
// accidental hits inside innocent words are implausible.
const SLUR_SUBSTRINGS = [
  'nigger', 'nigga', 'faggot', 'wetback', 'tranny', 'beaner', 'raghead',
];

// Matched only as an exact (normalized) token — too short/ambiguous for
// substring matching ("fag" is inside plenty of innocent strings).
const EXACT_TOKENS = ['fag', 'kike', 'spic', 'chink', 'gook', 'kys'];

// Matched against the whole normalized message (tokens joined by spaces).
const PHRASES = ['kill yourself', 'kill urself', 'rape you', 'rape u', 'child porn'];

/**
 * Returns true if the text trips the zero-tolerance filter.
 * Send paths should refuse the message outright (no auto-editing).
 */
export function isObjectionable(text) {
  if (!text) return false;
  const tokens = String(text).split(/\s+/).map(normalizeToken).filter(Boolean);
  const joined = tokens.join(' ');

  for (const p of PHRASES) {
    if (joined.includes(p)) return true;
  }
  for (const tok of tokens) {
    if (EXACT_TOKENS.includes(tok)) return true;
    for (const s of SLUR_SUBSTRINGS) {
      if (tok.includes(s)) return true;
    }
  }
  return false;
}
